<template>
  <section>
    <b-button
      type="is-primary"
      icon-left="clipboard-outline"
      @click="isCardModalActive = true"
    >
      Apply Now
    </b-button>
    <b-modal
      :active.sync="isCardModalActive"
      :width="640"
      scroll="keep"
      has-modal-card
      :canCancel="this.cancelSettings"
    >
      <div class="modal-card card">
        <header class="card-header -header">
          <p class="card-header-title">
            Beta Program Application
          </p>
          <a
            href="#"
            class="card-header-icon"
            aria-label="more options"
            v-on:click="closeModal"
          >
            <span class="icon">
              <b-icon icon="close" size="is-small"></b-icon>
            </span>
          </a>
        </header>
        <div class="card-content">
          <p class="subtitle is-size-6 has-text-grey has-text-centered">
            Let us know about yourself and how you plan to use CrowdFlik. Once
            we've recieved your information, we'll get in touch about next
            steps.
          </p>
          <div class="content">
            <form
              action="https://formspree.io/info@crowdflik.com"
              method="POST"
            >
              <b-field label="Name" aria-required required>
                <b-input
                  v-model="name"
                  placeholder="Enter your name"
                  type="text"
                  name="beta_application_name"
                ></b-input>
              </b-field>
              <b-field label="Email Address" aria-required required>
                <b-input
                  v-model="email"
                  placeholder="Provide your email address so we can contact you."
                  type="email"
                  name="beta_application_email"
                ></b-input>
              </b-field>
              <b-field label="Company/Organization (optional)">
                <b-input
                  v-model="company"
                  placeholder="Enter your the organization you work for (if applicable)."
                  type="text"
                  name="beta_application_company"
                ></b-input>
              </b-field>
              <b-field label="Role/Position (optional)">
                <b-input
                  v-model="role"
                  placeholder="If you're interested on behalf of an organization, describe your role."
                  type="text"
                  name="beta_application_role"
                ></b-input>
              </b-field>
              <b-field
                label="How do You Plan to use CrowdFlik? (optional)"
                aria-required
                required
              >
                <b-input
                  maxlength="200"
                  v-model="summary"
                  type="textarea"
                  name="beta_application_summary"
                  placeholder="Let us know if there are any features you're particularly interested in."
                ></b-input>
              </b-field>
              <div class="buttons">
                <b-button type="is-light">Cancel</b-button>
                <input
                  class="button"
                  v-bind:class="buttonClass"
                  type="submit"
                  value="Submit"
                />
              </div>
            </form>
          </div>
        </div>
      </div>
    </b-modal>
  </section>
</template>

<script>
export default {
  data() {
    return {
      isCardModalActive: false,
      cancelSettings: ["escape", "outside"],
      name: null,
      email: null,
      company: null,
      role: null,
      summary: null
    };
  },
  methods: {
    closeModal() {
      this.isCardModalActive = false;
    }
  },
  computed: {
    buttonClass: function() {
      if (this.name && this.email && this.summary) {
        return {
          "is-static": false,
          "is-success": true
        };
      } else {
        return {
          "is-static": true,
          "is-success": false
        };
      }
    }
  }
};
</script>

<style scoped lang="scss">
.-header {
  background-color: #f5f5f5;
}
</style>
